import { Component } from 'react';
import ErrorMessage from './ErrorMessage';
import NotFound from '../../pages/NotFound';
import { isNotFoundError } from './NotFoundError';

interface IErrorBoundaryState {
	hasError: boolean;
	errorMessage: string | null;
	isNotFound: boolean;
}

class ErrorBoundary extends Component<any, IErrorBoundaryState> {
	constructor(props: unknown) {
		super(props);
		this.state = { hasError: false, errorMessage: null, isNotFound: false };
	}

	static getDerivedStateFromError(error: Error): IErrorBoundaryState {
		const isNotFound = isNotFoundError(error);
		return { 
			hasError: true, 
			errorMessage: error.message,
			isNotFound 
		};
	}

	componentDidCatch(error: Error, info: unknown): void {
		console.log(error, info);
	}

	render(): any {
		const { hasError, errorMessage, isNotFound } = this.state;
		if (hasError) {
			if (isNotFound) {
				return <NotFound message={errorMessage ?? undefined} />
			}
			return <ErrorMessage message={errorMessage ?? 'Ett fel har uppstått'} />
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
